import React from 'react';
import { Button } from './ui/button';
import { Shield, Users, MapPin, Star } from 'lucide-react';
import { mockTrustBadges } from '../data/mock';

const iconMap = {
  'shield-check': Shield,
  'users': Users,
  'map-pin': MapPin,
  'star': Star
};

const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="pt-32 pb-20 bg-gradient-to-b from-brand-blue-50 to-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            Dependable Full-Service<br />Moving You Can Trust
          </h1>
          <p className="text-lg md:text-xl text-gray-600 mb-8 max-w-4xl mx-auto leading-relaxed">
            ATW Against the Wind Moving Services takes the stress out of moving with professional crews,
            transparent pricing, and coast-to-coast reliability. Whether you're moving across the street or across
            the country, we handle every detail with care so you can focus on your new beginning.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
            <Button
              onClick={() => scrollToSection('contact')}
              size="lg"
              className="bg-brand-blue hover:bg-brand-blue-700 text-white px-8 py-6 text-lg"
            >
              Get a Free Quote
            </Button>
            <Button
              onClick={() => scrollToSection('services')}
              size="lg"
              variant="outline"
              className="border-gray-300 text-gray-700 hover:bg-gray-50 px-8 py-6 text-lg"
            >
              View Our Services
            </Button>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
            {mockTrustBadges.map((badge) => {
              const Icon = iconMap[badge.icon];
              return (
                <div key={badge.id} className="flex flex-col items-center">
                  <Icon className="h-10 w-10 text-brand-blue mb-3" />
                  <p className="text-sm font-semibold text-gray-900">{badge.title}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;